import type { ItemFormData } from '../item-editor/types';

/**
 * The editor form maps field-for-field onto both the create and the update
 * payload. Every key is spelled out rather than spread: `update_item` applies
 * each field under `is not None` and reads `review_judgment` from
 * `model_fields_set`, so a key going missing here silently stops updating that
 * column instead of failing. The values arrive already checked against
 * features/verification/schemas/verificationItem.schema.
 */
export const buildItemPayload = (data: ItemFormData) => ({
  specification: data.specification,
  itemName: data.itemName,
  classifications: data.classifications,
  standardTarget: data.standardTarget,
  verificationMethodsPrimary: data.verificationMethodsPrimary,
  verificationMethodsSecondary: data.verificationMethodsSecondary,
  qualityRecordNo: data.qualityRecordNo,
  qualityRecordTitle: data.qualityRecordTitle,
  reviewJudgment: data.reviewJudgment,
  qualityRecordNoRight: data.qualityRecordNoRight,
  qualityRecordTitleRight: data.qualityRecordTitleRight,
});
